import { useEffect } from "react";

export const useFullscreenCenterOnExit = (latitude, longitude, handleReturnToLocation) => {
  useEffect(() => {

    const handleFullscreenChange = () => {
      // Check if we're exiting fullscreen (not entering it)
      const isFullscreen = document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement;

      if (!isFullscreen) {
        // User exited fullscreen, return to location
        handleReturnToLocation();
      }
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, [latitude, longitude, handleReturnToLocation]);

}


// WEBPACK FOOTER //
// ./src/containers/AdFormPage/LocationSelector/hooks/useFullscreenCenterOnExit.ts